import type { FaireProductEntity } from "../../entity_types/product";

export const p_87ef6646pb: FaireProductEntity = {
  token: "p_87ef6646pb",
  type: "product",
  name: "Knee Length Two Piece Suit Tulle Evening Dress",
  brandToken: "b_9x9dfusr4t",
  brandName: "Ever-Pretty",
  imageUrl:
    "https://cdn.faire.com/fastly/ae59db678182460459449c981c0de8a69e9d936e0953b352418ad171106fbd7e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33534ae46f67557d3a326eab6783ba26ab04f8a43206916d8a66d7fac19f9277.jpeg",
    "https://cdn.faire.com/fastly/6e5a9e0895aed8d7726eca657135cdda303a90c0dbb46a11f58c271e56957f0c.jpeg",
    "https://cdn.faire.com/fastly/928d2c4f5220ad5fd6bec0ee0b3d031d4c4e8d2684d53d10c1c4091b6353362c.jpeg",
    "https://cdn.faire.com/fastly/db36a08f9d3045c3db5b2391607294442b18963e82794a27832cc7bf867e17a8.jpeg",
    "https://cdn.faire.com/fastly/7cb132c273ea000f415da01390306ed7f859b9e2f701b2e2e345b8f34bec4ba2.jpeg",
  ],
  priceDollars: 52.64,
  description:
    "This exquisite evening dress embodies a captivating elegance with its deep V-neck and A-line silhouette. Crafted from lightweight tulle, it flows gracefully to knee-length, accentuating the wearer's curves. The two-piece design, comprising a bodice and skirt, offers versatility and comfort. Lined for added modesty, this dress is perfect for special occasions, exuding a sophisticated charm that is sure to turn heads\n\nFit: Please refer to Size Chart.\n\nLength: Knee Length.\n\nSleeve Style: Sleeveless.\n\nClosure: Concealed Zipper Up The Back.\n\nUndergarments: Not Padded, with Lining.",
  tags: [],
  msrpDollars: 105.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:59.843Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
